import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { MaintenanceNoticeComponent } from '../maintenance-notice/maintenance-notice.component';
import { MAINTENANCE_NOTICE, MAINTENANCE_NOTICE_SEEN_KEY } from '../maintenance-notice/maintenance-notice.constant';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  isLoading: boolean;

  constructor(private router: Router, private dialog: MatDialog) { 

    // Spinner for lazyload modules
    router.events.forEach((event) => { 
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });

    
  }

  ngOnInit(): void {
    // deferred to avoid ExpressionChangedAfterItHasBeenChecked
    setTimeout(() => this.openMaintenanceNotice());
  }

  // shown once after every login (login/logout clear localStorage) until the maintenance window ends
  openMaintenanceNotice() {
    if (localStorage.getItem(MAINTENANCE_NOTICE_SEEN_KEY) || new Date() > new Date(MAINTENANCE_NOTICE.showUntil)) {
      return;
    }
    this.dialog.open(MaintenanceNoticeComponent, {
      width: '640px',
      maxWidth: '95vw',
      disableClose: true,
      panelClass: 'maintenance-notice-dialog'
    }).afterClosed().subscribe(() => localStorage.setItem(MAINTENANCE_NOTICE_SEEN_KEY, 'true'));
  }

}
